export default "https://cdn-static.gokick.com/assets/4894ba43e4289cab16e653fbabc6637092de6282/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";